const VLIBRAS_ROOT = 'https://vlibras.gov.br/app';

let librasCarregado = false;
let widgetInicializado = false;


function activarCarregamentoAssetsVlibras(): void {
    const onloadHandler = window.onload;
    if (typeof onloadHandler === 'function') {
        onloadHandler.call(window, new Event('load'));
        return;
    }

    document.querySelectorAll('[vw] img[data-src]').forEach((node) => {
        const img = node as HTMLImageElement;
        const dataSrc = img.getAttribute('data-src');
        if (!dataSrc || img.getAttribute('src')) {
            return;
        }
        img.src = `${VLIBRAS_ROOT}/${dataSrc.replace(/^\//, '')}`;
    });
}

function scheduleActivarCarregamentoAssetsVlibras(): void {
    window.requestAnimationFrame(() => {
        activarCarregamentoAssetsVlibras();
    });
}

function createDOMObjects(): void {
    if (document.getElementById('tutorialLibras')) {
        return;
    }

    const dom = `
      <div vw class="enabled" id="tutorialLibras">
        <div vw-access-button class="active"></div>
        <div vw-plugin-wrapper>
          <div class="vw-plugin-top-wrapper"></div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', dom);
}

function initWidget(): void {
    if (!window.VLibras) {
        return;
    }

    if (!widgetInicializado) {
        new window.VLibras.Widget(VLIBRAS_ROOT);
        widgetInicializado = true;
    }

    scheduleActivarCarregamentoAssetsVlibras();
}

function importScriptFile(): void {
    const scriptExistente = document.querySelector('script[src*="vlibras-plugin.js"]');
    if (scriptExistente) {
        initWidget();
        return;
    }

    const script = document.createElement('script');
    script.src = `${VLIBRAS_ROOT}/vlibras-plugin.js`;
    script.onload = () => {
        initWidget();
    };
    script.onerror = () => {
        console.error('Erro ao carregar o script do VLibras');
        librasCarregado = false;
        widgetInicializado = false;
    };
    document.head.appendChild(script);
}

export function gerarFuncionalidadeDeLibras(): void {
    if (librasCarregado) {
        apresentarFuncionalidadeDeLibras();
        scheduleActivarCarregamentoAssetsVlibras();
        return;
    }

    createDOMObjects();
    importScriptFile();
    librasCarregado = true;
}

export function omitirFuncionalidadeDeLibras(): void {
    const elemento = document.getElementById('tutorialLibras');
    if (elemento) {
        elemento.classList.remove('enabled');
    }
}

export function apresentarFuncionalidadeDeLibras(): void {
    const elemento = document.getElementById('tutorialLibras');
    if (elemento) {
        elemento.classList.add('enabled');
    }
}
